<template>
  <partner-products-section v-if="isLoggedIn" :title="$t('Buy again')" :products="products" :loading="loading" />
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import PartnerProductsSection from 'theme/components/theme/blocks/Partners/PartnerProductsSection'

/**
 * "Recently bought" section on a partner's page (K2-2999) - the customer's own
 * previously-ordered, still-available products from this specific partner.
 */
export default {
  name: 'RecentlyBoughtFromPartner',
  components: {
    PartnerProductsSection
  },
  data () {
    return {
      products: [],
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      isLoggedIn: 'user/isLoggedIn',
      currentPartner: 'partners/getCurrentPartner'
    })
  },
  watch: {
    'currentPartner.code': {
      immediate: true,
      handler (code) {
        if (code) {
          this.loadProducts()
        }
      }
    }
  },
  methods: {
    ...mapActions({
      getRecentlyBoughtFromPartner: 'user/getRecentlyBoughtFromPartner'
    }),
    async loadProducts () {
      if (!this.isLoggedIn || !this.currentPartner) {
        this.products = []
        return
      }
      this.loading = true
      try {
        this.products = await this.getRecentlyBoughtFromPartner({
          partnerCode: this.currentPartner.code,
          locationCode: this.currentPartner.location_code
        })
      } catch (error) {
        this.products = []
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
